export default "__VITE_ASSET__BRX$$SXD__"